export default "__VITE_ASSET__CzDfCkYF__"